import { gql } from '@src/lib/gql'

/** L17/L18 booking-link panel: waive code + "N bookings from your link" (self/admin only). */
export const ADVISOR_BOOKING_LINK = gql`
  query AdvisorBookingLink {
    myAdvisorProfile {
      id
      advisorProfileId
      sessionFeeWaiveCode
      bookingLinkSessionsCount
    }
  }
`
